var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 1.49759C0.75 0.858592 1.4895 0.524841 1.96725 0.910341L2.03025 0.967341L6.53025 5.46734C6.65938 5.59649 6.73696 5.76831 6.74842 5.95058C6.75988 6.13285 6.70444 6.31304 6.5925 6.45734L6.53025 6.52784L2.03025 11.0278L1.95975 11.0901L1.902 11.1306L1.83 11.1711L1.803 11.1838L1.75275 11.2041L1.67175 11.2281L1.632 11.2356L1.587 11.2431L1.54425 11.2461L1.45575 11.2461L1.41225 11.2423L1.36725 11.2356L1.32825 11.2281L1.24725 11.2041L1.197 11.1838L1.098 11.1313L1.0305 11.0826L0.96975 11.0278L0.9075 10.9573L0.867 10.8996L0.8265 10.8276L0.81375 10.8006L0.7935 10.7503L0.7695 10.6693L0.762 10.6296L0.7545 10.5846L0.7515 10.5418L0.75 1.49759Z",
    fill: "#529CF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector (2).d3c71bca94b397d2e7b4a37cd96e2b5b.svg";
export { ForwardRef as ReactComponent };